import { render, staticRenderFns } from "./sub_section.vue?vue&type=template&id=7480e9cb&scoped=true"
import script from "./sub_section.vue?vue&type=script&lang=js"
export * from "./sub_section.vue?vue&type=script&lang=js"
import style0 from "./sub_section.vue?vue&type=style&index=0&id=7480e9cb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7480e9cb",
  null
  
)

export default component.exports